/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["li[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-size:16px}ul[_ngcontent-%COMP%]{padding-left:1em}div.optionb[_ngcontent-%COMP%]{padding-left:48px;padding-right:48px}@media (max-width:1023px){div.optionb[_ngcontent-%COMP%]{padding-left:10px}}"];
export { styles as styles };
